import { Grid as MuiGrid, GridProps as MuiGridProps } from '@mui/material';

/**
 * Grid should be used as the primary mechanism for layout of pages, alongside Container around the grid.
 *
 * ```js
 * import { Grid } from 'ui';
 * ```
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */

export default MuiGrid;
export type GridProps = MuiGridProps;
